import { motion } from "framer-motion";
import { PROCESS_STEPS } from "../lib/homevision";
import { fadeUp, viewportOnce, stagger } from "../lib/motion";

const VisionProcess = () => (
    <section
        data-testid="vision-process"
        className="relative bg-ink py-24 lg:py-36"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="flex items-center gap-6"
            >
                <p className="font-mono text-[13px] tracking-[0.3em] text-mist">
                    THE PROCESS
                </p>
                <span className="h-px flex-1 bg-white/10" />
                <p className="font-mono text-[13px] tracking-[0.3em] text-cad">
                    4 STEPS
                </p>
            </motion.div>

            <motion.h2
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                data-testid="vision-process-headline"
                className="mt-12 max-w-4xl font-display text-4xl font-semibold leading-[1.1] text-white md:text-6xl"
            >
                FROM DRAWING
                <span className="block">
                    TO VISION<span className="text-accent">.</span>
                </span>
            </motion.h2>

            <motion.div
                variants={stagger}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="mt-16 grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8"
            >
                {PROCESS_STEPS.map((s) => (
                    <motion.div
                        key={s.n}
                        variants={fadeUp}
                        data-testid={`process-step-${s.n}`}
                        className="border-t border-white/15 pt-6"
                    >
                        <p className="font-mono text-[13px] tracking-[0.3em] text-accent">
                            {s.n}
                        </p>
                        <h3 className="mt-5 font-display text-xl font-semibold tracking-tight text-white">
                            {s.title}
                        </h3>
                        <p className="mt-3 text-sm leading-relaxed text-mist">
                            {s.copy}
                        </p>
                    </motion.div>
                ))}
            </motion.div>
        </div>
    </section>
);

export default VisionProcess;
